<template>
  <div class="legend-container">
    <ul class="legend">
      <li
        v-for="(value, index) in values"
        :key="index"
        @mouseenter="$emit('emphasizeColor', value.color)"
        @mouseleave="$emit('equalizeColors')">
        <span class="color-square" :style="getColorStyle(value.color)"></span>
        {{ value.name }}
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'CategoryLegend',
  props: {
    /*
     * Array like this:
     * [
     *   {
     *     color: '#fdfdfd',
     *     name: 'Item'
     *   },
     *   ...
     * ]
     */
    values: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getColorStyle (color) {
      return 'background-color: ' + color;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  .legend {
    list-style: none;
    margin: 0;
    margin-top: $sp-margin-smaller;
  }

  .legend li {
    float: left;
    margin-right: $sp-margin-small;
    cursor: pointer;
    font-size: $fs-s;
  }

  .legend .color-square {
    float: left;
    width: $sp-margin-small;
    height: $sp-margin-small;
    margin-top: 0.25em;
    margin-right: $sp-margin-smaller;
  }

  .legend-container {
    margin-top: -$sp-margin-small;
    display: flex;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/explorer/correlation/CategoryLegend.vue